import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "mgt_history";
const EVENT_NAME = "mgt-history-changed";
const MAX_ITEMS = 20;

function read(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function write(ids: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // ignore storage errors
  }
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function useHistory() {
  const [history, setHistory] = useState<string[]>(() => read());

  useEffect(() => {
    const sync = () => setHistory(read());
    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const recordVisit = useCallback((id: string) => {
    const current = read();
    const next = [id, ...current.filter((item) => item !== id)].slice(
      0,
      MAX_ITEMS
    );
    write(next);
  }, []);

  const clearHistory = useCallback(() => write([]), []);

  return { history, recordVisit, clearHistory };
}